module.exports = __webpack_public_path__ + "img/materials-and-equipments-hover.e6e2ac8f.svg";